// Pesos como los lee una persona: «$ 1 160.00». Sin librerías: el
// formato es uno y es el de México.
export function pesos(v) {
  const n = Number(v || 0);
  const [entero, dec] = Math.abs(n).toFixed(2).split('.');
  const conEspacios = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${n < 0 ? '-' : ''}$ ${conEspacios}.${dec}`;
}

export function fechaCorta(v) {
  if (!v) return null;
  return new Date(v).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
}
